var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-container"},[_c('menu-button',{attrs:{"callback":_vm.menuButtonCallback}}),_c('poin-logo',{staticClass:"mx-auto"}),(_vm.authenticated)?_c('user-profile',{staticClass:"user-profile"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }